export { default } from './TravelHighlightsList'
